import React, {useEffect} from "react";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {getProductParamsTest} from "../../logic/setup/ProdcutParamsParser";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {parseUrl} from "../../logic/setup/ParametersParser";
import {parseDateStr} from "../../logic/setup/PriceCalculator";
import {logPageOpened} from "../model/utils";
import {FlexPrice} from "../price/FlexPrice";
import {GenericMessage} from "../thankyou/GenericMessage";
import {Price} from "../price/Price";
import {Sectors} from "../price/Sectors";


export function ForwardToPackage() {
    useEffect(() => {
        if (typeof window !== 'undefined') {

            let str = window.location.href
            str = str.replace("forwardtopackage", "begin")
            str = str.replace("2023H2-7.2023H2-SECRETS1-FIXED-PRICE", "2023H2-packageAllSecrets-FIXED-PRICE")
            str = str.replace("2023H2-8.2023H2-SECRETS2-FIXED-PRICE", "2023H2-packageAllSecrets-FIXED-PRICE")
            window.location.href = str;  // редирект на сайт example.com
        }
    }, []);

    return (
        <div>Redirect...</div>
    )
}
